import { Avatar } from "../../../components/Avatar";

export function Recipients({recipients}) {

  return (
    <div className="flex">
      {recipients.map(user => 
        <Avatar user={user} />
      )}
      <i className="fas fa-user text-gray-500 pl-2 pt-2" />
      <span className="pl-1 pt-1 text-gray-500 text-sm">{recipients.length} participants</span>
    </div>
  );
}